import * as styles from './source-column.scss';

type PropsType = {
    catalogName: string;
    catalogLogo: string;
};

export function SourceColumn(props: PropsType): JSX.Element {
    const {catalogName, catalogLogo} = props;

    return (
        <div className={styles.SourceColumn}>
            <img alt={catalogName} className={styles.SourceColumn_icon} src={catalogLogo} />

            <span>{catalogName}</span>
        </div>
    );
}
